const MovieInfo = [
    {
        title: "500 Days Of Summer",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788401/Movie%20Con/500_days_of_Summer_ywsqpi.jpg",
        caption: "You know what Sucks? Realising that everything you believe in, is incomplete and utter bullshit."
    },
    {
        title: "Interstellar",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788401/Movie%20Con/interstellar_ktc7wz.jpg",
        caption: "Murphy’s Law Doesn’t Mean That Something Bad Will Happen. It Means That Whatever Can Happen Will Happen."
    },
    {
        title: "TENET",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788436/Movie%20Con/tenet_u082sv.jpg",
        caption: "One Man's Probability Of Death...Is Another Man's Possibility For A Life"
    },
    {
        title: "The Theory Of Everything",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788326/Movie%20Con/theoryOfEverything_xhllxe.jpg",
        caption: "What Do Cosmologists Worship? .....A Single Unifying Equation That Explains Everything In The Universe."
    },
    {
        title: "3 Idiots",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788325/Movie%20Con/3idiots_nnjjsi.jpg",
        caption: "Dost fail ho jaye toh dukh hota hai … Lekin dost first aa jaye toh zyaada dukh hota hai"
    },
    {
        title: "Parasite",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788449/Movie%20Con/parasite_hlv97e.jpg",
        caption: "You know what kind of plan never fails? No plan. No plan at all. You know why? Because life cannot be planned."
    },
    {
        title: "The Big Bang Theory",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788385/Movie%20Con/bigBang3_dtvoyc.jpg",
        caption: "I'm Not Crazy. My Mother Had Me Tested."
    },
    {
        title: "Cosmos: A Spacetime Odyssey",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788399/Movie%20Con/cosmos_dkwyly.jpg",
        caption: "Beyond that horizon lie parts of the universe that are too far away. There hasn’t been enough time in the 13.8 billion year history of the universe for their light to have reached us."
    },
    {
        title: "Deadpool 2",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788452/Movie%20Con/deadpool2_oa7li9.jpg",
        caption: "I'm Batman!"
    },
    {
        title: "The Social Network",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788414/Movie%20Con/socialNetwork_lyrpns.jpg",
        caption: "We lived on farms, and then we lived in cities, and now we are going to live on the internet."
    },
    {
        title: "Shershah",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788359/Movie%20Con/shershah_pzw9oj.jpg",
        caption: "Yeh Dil Maange More!"
    },
    {
        title: "Orphan",
        imageSrc: "https://res.cloudinary.com/dqg4yv2bd/image/upload/c_fill/v1652788366/Movie%20Con/orphan2_fpd09s.jpg",
        caption: "I have a special surprise for you, Mommy!"
    },
];

export default MovieInfo;